/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import multiSamplesTutorialGif from 'assets/images/invitations/single-sample-modal/multi_samples_animation.gif';
import { hideModal as hideModalAction } from 'cards/actions/modalActions';
import Layout from '../Layout/Layout';
import styles from './styles.module.less';

export const TutorialModalBase = ({ hideModal }) => {
  return (
    <div className={styles.tutorialModalBox}>
      <img
        className={styles.tutorialAnimation}
        alt="Try Free Personalized Samples, Anytime"
        src={multiSamplesTutorialGif}
      />
      <div className={styles.tutorialModalText}>
        <Layout.Header>Try Free Personalized Samples, Anytime</Layout.Header>
        <Layout.Text>
          Touch and feel our paper in person, all printed with your names, wedding date, and photo.
        </Layout.Text>
      </div>
      <div className={styles.tutorialModalButtonBox}>
        <ButtonV2 className={styles.tutorialModalButton} onClick={() => hideModal()}>
          Get the Ball Rolling
        </ButtonV2>
      </div>
    </div>
  );
};

export const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModalAction()),
});

export default connect(null, mapDispatchToProps)(TutorialModalBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/MultiSample/TutorialModal.jsx